import { render, staticRenderFns } from "./PublishView.vue?vue&type=template&id=3639e50e&scoped=true"
import script from "./PublishView.vue?vue&type=script&lang=js"
export * from "./PublishView.vue?vue&type=script&lang=js"
import style0 from "./PublishView.vue?vue&type=style&index=0&id=3639e50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3639e50e",
  null
  
)

export default component.exports